import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AuthService } from './auth.service';

@Injectable()
export class AdminGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.auth.user
      .take(1)
      .map((user) => {
        console.log(user);
        return user.roles.admin === true || user.roles.superAdmin === true;
      })
      .do((loggedIn) => {
        if (!loggedIn) {
          console.log('only admins allowed');
          this.router.navigate(['/login']);
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/admin.guard.ts